module.exports = __webpack_public_path__ + "ebca6f8603498b700873995242dddc63.png";